import Papa from "papaparse";
import Logger from "../../common/utils/Logger";
import { createExtension } from "../../api/extension";

const trim = (v) => (typeof v === "string" ? v.trim() : v);

const handleCreateAll = async (results) => {
  const success = [];
  const failure = [];
  const rows = results?.data || [];

  Logger("CSV parsed, processing rows", rows.length);

  for (let x = 0; x < rows.length; x++) {
    const each = rows[x] || {};
    const params = {
      extension: trim(each.extension),
      password: each.password,
      phone: trim(each.phone),
      name: each.name,
      description: each.description,
    };
    const domain = trim(each.domain);

    try {
      const response = await createExtension(domain, params);
      Logger("Extension upload row", { row: x + 1, domain, params, response });
      if (response?.ok) {
        success.push(each);
      } else {
        failure.push({
          request: each,
          status: response?.status,
          error: response?.data,
        });
      }
    } catch (err) {
      // Catch per-row so a runtime error on one row (e.g. an unexpected
      // network failure that returns undefined) doesn't bail the loop
      // and silently leave the rest of the rows unprocessed.
      Logger("Extension upload row threw", { row: x + 1, err });
      failure.push({
        request: each,
        status: 0,
        error: err?.message || String(err),
      });
    }
  }

  return {
    ok: true,
    success,
    failure,
    total: rows.length,
  };
};

export const handleExtensionCreate = (file) => {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      // Trim whitespace around header names so "Extension " still maps to
      // the `extension` field.
      transformHeader: (h) => (typeof h === "string" ? h.trim() : h),
      complete: async (results) => {
        try {
          const out = await handleCreateAll(results);
          resolve(out);
        } catch (err) {
          Logger("Extension upload aborted", err);
          reject(err);
        }
      },
      error: (err) => {
        Logger("Papa parse error", err);
        reject(err);
      },
    });
  });
};

export const handleFailureFile = async (failure) => {
  return new Promise((resolve) => {
    resolve({ ok: true, data: JSON.stringify(failure, null, 2) });
  });
};
